import { Outlet } from 'react-router-dom';
import React from 'react';
import { GeneralNavbar } from '../components/GeneralNavbar';
import { Footer } from '../components/Footer';
import { Box } from '@mui/material';
import { StyledLayout } from '../theme/StyledElements';

export function SubscriptionLayout(): React.ReactElement {
    return (
        <StyledLayout>
            <Box>
                <GeneralNavbar isBottomBorderRequired />
                <Outlet />
            </Box>
            <Footer />
        </StyledLayout>
    );
}
